import { PText } from '@porsche-design-system/components-react'
import clsx from 'clsx'
import React from 'react'

import { PortalContext } from '../../../utils/PortalContext'

import styles from './contenttoast.module.css'

const ContentToast = () => {
  const { toast, toastContent } = React.useContext(PortalContext)

  return (
    <div className={clsx(styles.toast, { [styles.active]: toast })}>
      <PText theme='dark'>{toastContent}</PText>
    </div>
  )
}

export default ContentToast
